<template>
  <div class="f-socialWall" v-show="arePostsPresent">
    <h2 class="title-container clickable" @click="loadSocialWall">{{activeLanguage.socialWall}}</h2>
    <div class="post-container">
      <div :class="getContainerClass" v-masonry transition-duration="0.3s" item-selector=".item" :fit-width="true">
        <div v-masonry-tile class="item" v-for="(post, index) in posts" :key="index"
             :class="[{'card-mobile': $store.getters.isMobileValue}]">
          <social-card :post-content="post"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import SocialWallPage from '../socialsPageComponents/SocialWallPage'
  import SocialCard from '../../utilComponents/SocialCard'

  import Vue from 'vue'
  import {VueMasonryPlugin} from 'vue-masonry'

  Vue.use(VueMasonryPlugin)

  export default {
    name: 'SocialWall',
    components: {SocialCard},
    data () {
      return {
        posts: [],
        areInformationOutdated: false,
        profilesToUpdate: [],
        isSmallWindow: false
      }
    },
    computed: {
      activeLanguage () {
        return this.$translations[this.$store.getters.currentLanguageValue]
      },
      arePostsPresent () {
        return this.posts.length > 0
      },
      getContainerClass () {
        return this.isSmallWindow ? 'post-container-mobile' : 'post-container'
      }
    },
    methods: {
      loadSocialWall () {
        this.$store.commit('setCurrentView', SocialWallPage)
        this.$router.push('/social-wall')
      },
      fetchMostRecentPosts () {
        let self = this
        this.$http.get(this.$PATH_NAME + 'social/getHighlights/').then((response) => {
          self.posts = response.body
        })
      },
      handleOutDatedPost (userScreenName) {
        this.areInformationOutdated = true
        if (!this.profilesToUpdate) {
          this.profilesToUpdate = []
        }
        if (!this.profilesToUpdate.includes(userScreenName)) {
          this.profilesToUpdate.push(userScreenName)
          console.log('Ask to update picture of ' + userScreenName)
        }
      },
      updateOutDatedPost (userScreenName) {
        let self = this
        this.$http.get(this.$PATH_NAME + '/social/updateProfileInformation/profile=' + userScreenName).then((response) => {
          self.posts.forEach(post => {
            if (post.user.screenName === userScreenName) {
              post.user.profileImageUrl = response.body
            }
          })
        }
        ).catch(function (err) {
          this.handleError(err)
        })
      },
      checkWindowSize () {
        if ((!this.isSmallWindow) && window.innerWidth < 1051) {
          this.isSmallWindow = true
        } else if (this.isSmallWindow && window.innerWidth > 1051) {
          this.isSmallWindow = false
        }
      }
    },
    mounted () {
      this.fetchMostRecentPosts()
      this.checkWindowSize()
      window.addEventListener('resize', () => this.checkWindowSize())
    }
  }
</script>

<style scoped>

  .f-socialWall {
    border-radius: 8px;
    height: 100%;
    padding: 3% 0 0;

  }

  .post-container {
    margin-bottom: 2%;
  }

  .post-container-mobile {
    width: 100% !important;
  }

  .card-mobile > a > div {
    max-width: 500px !important;
  }

</style>



// WEBPACK FOOTER //
// src/components/pagesComponents/homePageComponents/SocialWall.vue